import React from "react";
import { Modal, Button } from "react-bootstrap";
import linkedin from "./in.png"

export default function MyVerticallyCenteredModal({ show, onHide, title, position, description, linkedIn, img }) {
    return (
        <Modal show={show} onHide={onHide} centered style={{zIndex: '999999', marginTop: "3%", width: "80%", marginLeft: "12%" }}>
            <Modal.Header closeButton>
                <Modal.Title style={{width: "100%", textAlign: "center", fontSize: "1.5rem", fontWeight: "bolder" }}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{alignItems: "center", display: "flex", flexDirection: "column" }}>
                <img src={img} alt={title} style={{width: "200px", height: "200px", borderRadius: "50%", alignSelf: "center !imnportant" }} />
                <h6 style={{ marginTop: "10px", fontSize: "1.3rem", color: "gray", fontWeight: "bold" }}>{position}</h6>
                <p style={{ fontWeight: "lighter", textAlign: 'justify', width: "90%", color: "gray" }}>{description}</p>
                {linkedIn && (
                    <a style={{ marginLeft: "40 %", alignItems: "center" }} href={linkedIn} target="_blank" rel="noopener noreferrer">
                        <img width={"20%"} style={{ marginLeft: "40%" }} src={linkedin} alt="linkedin link" />
                    </a>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
